export enum EStorageKeys {
  CURRENT_USER = 'currentUser',
  ACCESS_TOKEN = 'accessToken',
  ID_TOKEN = 'idToken',
  REFRESH_TOKEN = 'refreshToken',
  DELIVERY_NOTE_STATUS_FILTER = 'deliveryNoteStatusFilter',
  ORDER_DOCUMENT_STATUS_FILTER = 'orderDocumentStatusFilter',
  DELIVERY_DATE_WERK_FILTER = 'deliveryDateWerkFilter',
}
